import axios from "axios";
import authHeader from "./auth-header";
const API_URL = process.env.VUE_APP_API_URL;

class FavoriteService {
  // allow passing { list_id } to filter on the backend
  getFavorites(params = {}) {
    return axios.get(`${API_URL}favorites`, {
      headers: authHeader(),
      params,
    });
  }

  addFavorite(data) {
    return axios.post(`${API_URL}favorites`, data, { headers: authHeader() });
  }

  updateFavorite(favoriteId, data) {
    
    return axios.put(`${API_URL}favorites/${favoriteId}`, data, {
      headers: authHeader(),
    });
  }

  
  // removeFavorite(favoriteId) {
  //   return axios.delete(`${API_URL}favorites/${favoriteId}`, {
  //     headers: authHeader(),
  //   });
  // }

  removeFavorite(listingId) {
  return axios.delete(`${API_URL}favorites/${listingId}`, {
    headers: authHeader(),
  });
}

}

export default new FavoriteService();
